import React from 'react';

export const getPreviewKind = (fileName = '', mimeType = '') => {
  const ext = (fileName || '').split('.').pop()?.toLowerCase() || '';
  const mime = (mimeType || '').toLowerCase();
  if (mime.startsWith('image/') || ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) {
    return 'image';
  }
  if (mime === 'application/pdf' || ext === 'pdf') {
    return 'pdf';
  }
  return 'other';
};

export const buildServerFileUrl = (imageUrl, fileName) => {
  if (!fileName) return '';
  const base = (imageUrl || '').replace(/\/$/, '');
  const path = String(fileName).replace(/^\//, '');
  return `${base}/${path}`;
};

/** Build preview model from attachment grid row */
export const buildAttachmentPreview = (row) => {
  if (!row) return null;

  const file = row.file;
  const fileName = row.fileName || file?.name || '';

  if (file instanceof File) {
    const url = URL.createObjectURL(file);
    return {
      url,
      fileName: file.name,
      kind: getPreviewKind(file.name, file.type),
      blobUrl: url,
    };
  }

  if (fileName) {
    const imageUrl = process.env.REACT_APP_IMAGE_URL;
    return {
      url: buildServerFileUrl(imageUrl, fileName),
      fileName,
      kind: getPreviewKind(fileName),
      isRemote: true,
    };
  }

  return null;
};

export const revokePreviewUrl = (preview) => {
  if (preview?.blobUrl) {
    URL.revokeObjectURL(preview.blobUrl);
  }
};

export const AttachmentPreviewBody = ({ preview }) => {
  if (!preview?.url) {
    return <p className="text-muted text-center mb-0">No preview available.</p>;
  }

  const { url, kind, fileName } = preview;

  if (kind === 'image') {
    return <img src={url} alt={fileName || 'preview'} style={{ width: '100%', maxHeight: '75vh', objectFit: 'contain' }} />;
  }

  if (kind === 'pdf') {
    return <iframe title={fileName || 'PDF preview'} src={url} style={{ width: '100%', height: '75vh', border: 'none' }} />;
  }

  return (
    <div className="text-center p-4">
      <p className="mb-2">Preview is not available for this file type.</p>
      {fileName && <p className="text-muted small mb-3">{fileName}</p>}
      <a href={url} target="_blank" rel="noopener noreferrer" className="mainbtn">
        Open / Download
      </a>
    </div>
  );
};
